<script lang="ts">
    import { shopColours } from '$lib/stores/shopColours';

    export let data;
    const shop: Shop = data.shop;
    $shopColours = shop.colours;
</script>


<slot />


